import { BaseError } from '../../_base/lang/BaseError';

export class InvalidCredentialsError extends BaseError {
}
